<template>
   <PageHeader></PageHeader>
  <div class="portfolio">
    <h3>Portfolio</h3>
    
    <div class="photo-grid">
  <div
    class="photo-item"
    v-for="(item, index) in photoItems"
    :key="index"
  >
    <img
      :src="item.src"
      :alt="item.caption"
      @click="openLightbox(index)"
    />
  </div>
</div>

    <div
      v-if="showLightbox"
      class="lightbox-overlay"
      @click.self="closeLightbox"
      >
      <button class="lightbox-close" @click="closeLightbox">&times;</button>
      <button class="lightbox-prev" @click="prevPhoto">&#10094;</button>
      <div class="lightbox-content">
	<img
	  :src="photoItems[currentIndex].src"
	  class="lightbox-image"
	  alt="Large view"
	  />
	<div class="lightbox-caption">
	  {{ photoItems[currentIndex].caption }}
	</div>
      </div>
   
      <button class="lightbox-next" @click="nextPhoto">&#10095;</button>
    </div>
    
    <!-- Lightbox Overlay
    <div
      v-if="showLightbox"
      class="lightbox-overlay"
      @click.self="closeLightbox"
    >
      <button class="lightbox-close" @click="closeLightbox">&times;</button>
      <button class="lightbox-prev" @click="prevPhoto">&#10094;</button>
      <div class="lightbox-content">
      <img
        :src="photos[currentIndex]"
        class="lightbox-image"
        alt="Large view"
	/>
      <div class="lightbox-caption">{{ captions[currentIndex] }}
      </div>
       
</div>
-->

  </div>
</template>

<script>
import PageHeader from './PageHeader.vue';


export default {
name: 'Portfolio',
components: {
    PageHeader
  },
  data() {
  return {
  showLightbox: false,
  currentIndex: 0,
  photoItems: [
    { src: "/portfolio/1.jpg", caption: "Howth, Ireland" },
    { src: "/portfolio/4.jpg", caption: "Howth, Ireland" },
    { src: "/portfolio/5.jpg", caption: "Howth, Ireland" },
    { src: "/portfolio/9.jpg", caption: "Howth, Ireland" },
    { src: "/portfolio/18.jpg", caption: "Amsterdam" },
    { src: "/portfolio/19.jpg", caption: "Amsterdam" },
    { src: "/portfolio/20.jpg", caption: "Amsterdam" },
    { src: "/portfolio/21.jpg", caption: "Amsterdam" },
    { src: "/portfolio/23.jpg", caption: "Amsterdam" },
    { src: "/portfolio/25.jpg", caption: "Amsterdam" },
    { src: "/portfolio/26.jpg", caption: "Amsterdam" },

    { src: "/portfolio/28.jpg", caption: "Amsterdam" },
    { src: "/portfolio/29.jpg", caption: "Amsterdam" },
    { src: "/portfolio/30.jpg", caption: "Amsterdam" },
    { src: "/portfolio/31.jpg", caption: "Amsterdam" },
    { src: "/portfolio/32.jpg", caption: "Amsterdam" },
    { src: "/portfolio/33.jpg", caption: "Amsterdam" },
    { src: "/portfolio/34.jpg", caption: "Amsterdam" },
    { src: "/portfolio/35.jpg", caption: "Amsterdam" },
    { src: "/portfolio/36.jpg", caption: "Leipzig, Germany" },
    { src: "/portfolio/37.jpg", caption: "Leipzig, Germany" },
    { src: "/portfolio/39.jpg", caption: "Leipzig, Germany" },
    { src: "/portfolio/41.jpg", caption: "Berlin" },
    { src: "/portfolio/43.jpg", caption: "Berlin" },
    { src: "/portfolio/44.jpg", caption: "Berlin" },
    { src: "/portfolio/45.jpg", caption: "Berlin" },
    { src: "/portfolio/46.jpg", caption: "Berlin" },
    { src: "/portfolio/47.jpg", caption: "Berlin" },
    { src: "/portfolio/48.jpg", caption: "Berlin" },

    { src: "/portfolio/50.jpg", caption: "Berlin" },
    { src: "/portfolio/51.jpg", caption: "Berlin" },
    { src: "/portfolio/52.jpg", caption: "Berlin" },
    { src: "/portfolio/53.jpg", caption: "Berlin" },
    { src: "/portfolio/54.jpg", caption: "Hamburg" },
    { src: "/portfolio/55.jpg", caption: "Hamburg" },
    { src: "/portfolio/56.jpg", caption: "Hamburg" },
    { src: "/portfolio/57.jpg", caption: "Hamburg" },
    { src: "/portfolio/58.jpg", caption: "Hamburg" },
    { src: "/portfolio/59.jpg", caption: "Hamburg" },
    { src: "/portfolio/60.jpg", caption: "Hamburg" },
    { src: "/portfolio/61.jpg", caption: "Hamburg" },
    { src: "/portfolio/62.jpg", caption: "Hamburg" },
    { src: "/portfolio/63.jpg", caption: "Hamburg" },
    { src: "/portfolio/64.jpg", caption: "Hamburg" },

    { src: "/portfolio/66.jpg", caption: "Hamburg" },
    { src: "/portfolio/67.jpg", caption: "Amsterdam" },
    { src: "/portfolio/68.jpg", caption: "Frankfurt" },
    { src: "/portfolio/69.jpg", caption: "Köln" },
    { src: "/portfolio/70.jpg", caption: "Köln" },
    { src: "/portfolio/71.jpg", caption: "Köln" },
    { src: "/portfolio/72.jpg", caption: "Köln" },
    { src: "/portfolio/73.jpg", caption: "Köln" },
      { src: "/portfolio/74.jpg", caption: "Paris" },
      { src: "/portfolio/75.jpg", caption: "Paris" },

      { src: "/portfolio/78.jpg", caption: "Paris" },
      { src: "/portfolio/79.jpg", caption: "Paris" },
      { src: "/portfolio/80.jpg", caption: "Paris" },

      { src: "/portfolio/82.jpg", caption: "Paris" },
      { src: "/portfolio/83.jpg", caption: "Paris" },
      { src: "/portfolio/84.jpg", caption: "Paris" },
      { src: "/portfolio/85.jpg", caption: "Paris" },
      { src: "/portfolio/86.jpg", caption: "Paris" },
      { src: "/portfolio/87.jpg", caption: "Paris" },
      { src: "/portfolio/88.jpg", caption: "Paris" },
      { src: "/portfolio/89.jpg", caption: "Paris" },
      { src: "/portfolio/90.jpg", caption: "Paris" },
      { src: "/portfolio/91.jpg", caption: "Paris" },
      { src: "/portfolio/92.jpg", caption: "Paris" },
      { src: "/portfolio/93.jpg", caption: "Paris" },
      { src: "/portfolio/94.jpg", caption: "Paris" },
      { src: "/portfolio/95.jpg", caption: "Paris" },

      { src: "/portfolio/97.jpg", caption: "Paris" },
      { src: "/portfolio/98.jpg", caption: "Paris" },
      { src: "/portfolio/99.jpg", caption: "Paris" },
      { src: "/portfolio/100.jpg", caption: "Paris" },
      { src: "/portfolio/101.jpg", caption: "Paris" },
      { src: "/portfolio/102.jpg", caption: "Paris" },
      { src: "/portfolio/103.jpg", caption: "Paris" },
      { src: "/portfolio/104.jpg", caption: "Paris" },
      { src: "/portfolio/105.jpg", caption: "Paris" },
      { src: "/portfolio/106.jpg", caption: "Paris" },
      { src: "/portfolio/107.jpg", caption: "Paris" },
      { src: "/portfolio/108.jpg", caption: "Paris" },
      { src: "/portfolio/109.jpg", caption: "Paris" },
      { src: "/portfolio/110.jpg", caption: "Paris" },
      { src: "/portfolio/111.jpg", caption: "Paris" },
      { src: "/portfolio/112.jpg", caption: "Paris" },
      { src: "/portfolio/113.jpg", caption: "Paris" },
      { src: "/portfolio/114.jpg", caption: "Paris" },
      { src: "/portfolio/115.jpg", caption: "Paris" },
      { src: "/portfolio/116.jpg", caption: "Paris" },
      { src: "/portfolio/117.jpg", caption: "Paris" },

      { src: "/portfolio/118.jpg", caption: "Utrecht" },
      { src: "/portfolio/119.jpg", caption: "Utrecht" },
      { src: "/portfolio/120.jpg", caption: "Utrecht" },
      { src: "/portfolio/122.jpg", caption: "Utrecht" },      
      { src: "/portfolio/121.jpg", caption: "Amsterdam" },

      { src: "/portfolio/123.jpg", caption: "Amsterdam" },

      { src: "/portfolio/125.jpg", caption: "Amsterdam" },      
      { src: "/portfolio/126.jpg", caption: "Amsterdam" },
      { src: "/portfolio/127.jpg", caption: "Amsterdam" },
      { src: "/portfolio/128.jpg", caption: "Amsterdam" },
      { src: "/portfolio/129.jpg", caption: "Amsterdam" },
      { src: "/portfolio/130.jpg", caption: "Amsterdam" },
     { src: "/portfolio/143.jpg", caption: "Amsterdam" },

      { src: "/portfolio/144.jpg", caption: "Amsterdam" },
      { src: "/portfolio/145.jpg", caption: "Amsterdam" },
      { src: "/portfolio/146.jpg", caption: "Amsterdam" },      
      { src: "/portfolio/147.jpg", caption: "Amsterdam" },
      { src: "/portfolio/148.jpg", caption: "Amsterdam" },
      { src: "/portfolio/149.jpg", caption: "Amsterdam" },
      { src: "/portfolio/150.jpg", caption: "Amsterdam" },
      { src: "/portfolio/151.jpg", caption: "Amsterdam" },
      
      { src: "/portfolio/152.jpg", caption: "Amsterdam" },
      { src: "/portfolio/153.jpg", caption: "Amsterdam" },
      { src: "/portfolio/154.jpg", caption: "Amsterdam" },
      { src: "/portfolio/155.jpg", caption: "Amsterdam" },
      { src: "/portfolio/156.jpg", caption: "Amsterdam" },
      { src: "/portfolio/157.jpg", caption: "Amsterdam" },
      { src: "/portfolio/158.jpg", caption: "Amsterdam" },      
      

      { src: "/portfolio/131.jpg", caption: "Norway" },      
      { src: "/portfolio/132.jpg", caption: "Norway" },
      { src: "/portfolio/134.jpg", caption: "Norway" },
      { src: "/portfolio/135.jpg", caption: "Norway" },
      { src: "/portfolio/136.jpg", caption: "Norway" },
      { src: "/portfolio/137.jpg", caption: "Norway" },      
      { src: "/portfolio/138.jpg", caption: "Norway" },      
      { src: "/portfolio/139.jpg", caption: "Norway" },
      { src: "/portfolio/140.jpg", caption: "Norway" },      
      { src: "/portfolio/141.jpg", caption: "Norway" },


 
  ]
};

  },
  methods: {

    openLightbox(index) {
      this.currentIndex = index;
      this.showLightbox = true;
    },
    closeLightbox() {
      this.showLightbox = false;
    },
    prevPhoto() {
      this.currentIndex =
        (this.currentIndex + this.photoItems.length - 1) % this.photoItems.length;
    },
    nextPhoto() {
      this.currentIndex =
        (this.currentIndex + 1) % this.photoItems.length;
    },
  },
    mounted() {
	console.log("MOUNTED")
	console.log("PHOTOS:",this.photoItems.length)
	}
};
</script>

<style scoped>

.portfolio h3 {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;    /* lighter still */
  font-size: 1.5rem;   /* 24px */
  line-height: 1.4;
  margin: 1rem 0;
  text-align: center;    /* often nice for titles */
  color: orange;
}

.portfolio h2 {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  text-align: center;    /* often nice for titles */
}
  .portfolio h1 {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  text-align: center;    /* often nice for titles */
}

.portfolio {
  padding: 16px;
}

.photo-grid {
    display: grid;
    /*
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
   */
     grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}


.photo-item img {
  width: 100%;
  height: auto;
  object-fit: cover;
  cursor: pointer;
  border-radius: 8px;
  transition: transform 0.2s;
}



  /*
  .photo-item {

  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 8px;
  }
  */
.photo-item img:hover {
  transform: scale(1.05);
}

.caption {
  padding: 8px;
  text-align: center;
  font-size: 0.9rem;
  color: #555;
  background: #fff;
}

/* Lightbox Styles */
.lightbox-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.lightbox-content {
  max-width: 90%;
  max-height: 80%;
  text-align: center;
}

.lightbox-image {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 4px;
}

.lightbox-caption {
  margin-top: 12px;
  color: #fff;
  font-size: 1rem;
}

.lightbox-close,
.lightbox-prev,
.lightbox-next {
  position: absolute;
  background: transparent;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
}

.lightbox-close {
  top: 20px;
  right: 30px;
}

.lightbox-prev {
  top: 50%;
  left: 30px;
  transform: translateY(-50%);
}

.lightbox-next {
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
}
</style>
